export const sheetFont = (bold) => {
  return {
    name: 'Arial',
    size: 10,
    bold: bold,
  };
};